/*=========================================================================================
    File Name: swiper.js
    Description: swiper plugin
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: PIXINVENT
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
var mySwiper2 = new Swiper('.swiper-paginations', {
    slidesPerView: 1,
    pagination: {
        el: '.swiper-pagination',
    },
});
